export default {
    mounted() {
        const app = document.querySelector('[data-app]')
        if (app && this.$el && this.$el.nodeType === 1 && this.$el.parentNode !== app) {
            app.appendChild(this.$el)
        }
    }
}
